import { useTranslation } from "react-i18next"
import { Box } from "theme-ui"
import { Button, Input } from "components"

export const MessageSimulationSystem = () => {
 // language translator
 const { t } = useTranslation("translation")
 return (
  <div className="w-[96%] mx-auto mt-6">
   <h1 className="Jakarta-font font-semibold pb-3">{t("messageSimulation")}</h1>
   <Box bg="highlight" className="Jakarta-font py-5 px-4 rounded">
    <h1 className="font-semibold">{t("report")}</h1>
    <div className="flex justify-between py-4">
     <div className="flex flex-col justify-center w-[48%]">
      <Input
       label={`${t("time")}:`}
       id="time"
       className="bg-gray py-2 outline-none rounded px-2 text-black"
       type="date"
      />
     </div>
     <div className="flex flex-col justify-center w-[48%]">
      <Input
       label={`${t("Report")}:`}
       id="length"
       className="bg-gray py-2 outline-none rounded px-2 text-black"
       type="number"
      />
     </div>
    </div>
    <div className="flex justify-end">
     {" "}
     <div>
      <Button size={"xl"}>{t("send")}</Button>
     </div>
    </div>
   </Box>
  </div>
 )
}
